module.exports = __webpack_public_path__ + "static/media/fps.46250fa8.gif";